let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7kiNM"), load("5MjBi"), load("dhqJV")]).then(() => parcelRequire('fzbVm'));